class KitView {
  constructor() {
    this.modal = new HimiTheme.Modal();
    this.isOpen = false;
    this.isLoading = false;

    addEventDelegate({
      selector: ".kitview-button",
      handler: (e, target) => {
        e.preventDefault();
        if (this.isLoading) return;
        this.target = target;
        this.toggleLoading(true);
        const productHandle = target.dataset.productHandle;
        if (productHandle) this.loadKitView(productHandle);
      },
    });

    window.HimiEvents.subscribe(HimiTheme.pubSubEvents.cartUpdate, () => {
      if (this.modal) this.close();
    });
  }

  loadKitView(productHandle) {
    if (this.isOpen) {
      this.close();
    }

    this.loadAssets([HimiThemeStyles.hotspotsImage, HimiThemeStyles.collageTabs], "kit-view-assets")
      .then(() =>
        fetchSection("product-accessories-kit", { url: `${window.HimiSettings.base_url}products/${productHandle}?view=kitview` })
      )
      .then((html) => {
        this.modalContent = html.querySelector("section");

        return this.loadAssets(
          [HimiThemeScripts.productBundles, HimiThemeScripts.hotspotsImage, HimiThemeScripts.collageTabs],
          "variants-picker"
        ).then(() => {
          this.modal.appendChild(this.modalContent);
          this.modal.setWidth("1360px");
          this.modal.open();
          this.toggleLoading(false);
          this.isOpen = true;
        });
      })
      .then(() => {
        document.dispatchEvent(
          new CustomEvent("kit-view:loaded", {
            detail: { productUrl: this.target.dataset.productHandle },
          })
        );
      })
      .catch((error) => {
        console.error('KitView load error:', error);
        this.toggleLoading(false);
      });
  }

  loadAssets(assets, key) {
    return new Promise((resolve, reject) => {
      loadAssetsNew(assets, key, resolve, reject);
    });
  }

  close(e) {
    this.modal.close(e);
    this.isOpen = false;
  }

  toggleLoading(isLoading) {
    this.isLoading = isLoading;
    if (isLoading) {
      this.target.classList.add("spinner-loading");
    } else {
      this.target.classList.remove("spinner-loading");
    }
  }
}

HimiTheme.KitView = new KitView();